import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Col,
  Row,
  InputNumber,
  DatePicker,
  Select,
  Checkbox,
  Modal,
} from 'antd'
import '../../css/schedule.scss'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleFilled,
  FormOutlined,
} from '@ant-design/icons'
import { setExercises } from '../../store/action/schedule.action'
import serviceInterface from '../../services/service.interface'
import moment from 'moment'
import { EXERCISE_ACTION_TYPE } from '../../services/schedule.service'
import { constants } from '../../constants'
import util from '../../util/util'
import { findIndex } from 'lodash'

const SCHED_TYPE = {
  STARTDATE: 'STARTDATE',
  ENDDATE: 'ENDDATE',
}

const Schedule = (props) => {
  var { startdate, enddate, ...rest } = props.schedule
  const [interval, setInterval] = useState(props.schedule?.interval || 7)
  const [edit, setEdit] = useState(false)
  const [input, setInput] = useState({ startdate, enddate, interval })
  const [applyAll, setApplyAll] = useState(false)
  var [skiponsurgerydate, setSkip] = useState(props.schedule?.skiponsurgerydate)
  useEffect(() => {
    props.editChange(edit)
    props.setOthersEdit(edit)
  }, [edit])

  useEffect(() => {
    if (props.schedule) {
      setInterval(props.schedule?.interval || 7);
      setSkip(props.schedule?.skiponsurgerydate);
      setInput({
        startdate: props.schedule?.startdate,
        enddate: props.schedule?.enddate,
        interval: props.schedule?.interval || 7,
      });
    }
  }, [props.schedule]);

  useEffect(() => {
    setInterval(props.schedule.interval || 7)
  }, [props.schedule.interval])

  useEffect(() => setSkip(props.schedule.skiponsurgerydate), [props.schedule])

  var handleChange = (type, value) => setInput({ ...input, [type]: value })
  var handleSubmit = () => {
    props.setExercises(
      serviceInterface
        .ScheduleService()
        .modifyExerciseArray(
          { ...rest, ...input,skiponsurgerydate },
          props.exercises,
          EXERCISE_ACTION_TYPE.EDIT
        )
    )
    setEdit(false)
  }

  var handleSubmitAndSkipToAll = () => {
    let newList = [...props.exercises]
    let exer = { ...rest, ...input, skiponsurgerydate }
    newList[findIndex(newList, { _id: exer._id })] = exer

    props.setExercises(
      serviceInterface
        .ScheduleService()
        .modifyAllExercises(
          [...newList],
          input,
          props.patient.surgery?.date,
          true
        )
    )
    setEdit(false)


  }

  var showConfirmDeleteBox = () => {
    Modal.confirm({
      title: 'Are you sure you want apply this schedule to all ?',
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => handleSubmitToAll(),
    })
  }

  var handleSubmitToAll = (skipToAll=false) => {
    props.setExercises(
      serviceInterface
        .ScheduleService()
        .modifyAllExercises(
          [...props.exercises],
          {...input,skiponsurgerydate},
          props.patient.surgery?.date,
          skipToAll
        )
    )
    setApplyAll(false)
    setEdit(false)
  }

  var getDays = (date) =>
    moment(date)
      .startOf('day')
      .diff(moment(props.patient?.surgery?.date).startOf('day'), 'days')

  var handleCancel = () => {
    setInput({ startdate, enddate })
    setEdit(false)
  }

  var actual_date = (number) =>
    moment(props.patient?.surgery?.date).add(number, 'days').startOf('day')

  var disabledDate = (current, type) => {
    var default_validation =
      current && current < moment().add(1, 'd').startOf('day')
    switch (type) {
      case SCHED_TYPE.STARTDATE:
        return default_validation || current > actual_date(input.enddate)
      case SCHED_TYPE.ENDDATE:
        return (
          default_validation ||
          moment(current)
            .startOf('day')
            .isSameOrBefore(actual_date(input.startdate))
        )
      default:
        break
    }
  }

  var disablePicker = (number) => {
    return moment().startOf('day').isAfter(actual_date(number))
  }

  var renderIntervalOptions = () => {
    return constants.INTERVAL_OPTIONS.map((data) => (
      <Select.Option style={{ fontSize: '1rem' }} value={data.index}>
        {data.name}
      </Select.Option>
    ))
  }

  var showConfirmeBoxSkipForAll = (e) => {
    Modal.confirm({
      title: `Do you want apply 'Skip on surgery date' to all exercises?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      cancelText: 'No',
      onOk: handleSubmitAndSkipToAll,
      onCancel: handleSubmit,
    })
  }

  return (
    <Row hidden={props.hidden} align='middle' style={{ height: '100%' }}>
      <Col flex={'10%'}>&nbsp;</Col>
      <Col flex={'auto'}>
        <Row className='exeCard'>
          <Col className='confHeader exeCard' flex={'20%'}>
            <Row hidden={edit}>
              <Col flex={'auto'}>
                <Row>
                  S
                  {startdate >= 0
                    ? '+' + startdate.toString()
                    : startdate.toString()}
                </Row>
                <Row>
                  {moment(props.patient?.surgery?.date)
                    .add(startdate, 'd')
                    .format('MM/DD/YYYY')}
                </Row>
              </Col>
            </Row>
            <Row hidden={!edit}>
              {props.editPage ? (
                <DatePicker
                  showToday={false}
                  /*disabled={disablePicker(startdate)}
                                    disabledDate={(current) => disabledDate(current, SCHED_TYPE.STARTDATE)}*/
                  value={moment(props.patient?.surgery?.date).add(
                    input.startdate,
                    'd'
                  )}
                  onChange={(e) =>
                    e
                      ? handleChange('startdate', getDays(e.toDate()))
                      : handleChange('startdate', input.startdate)
                  }
                />
              ) : (
                <InputNumber
                  onChange={(e) => handleChange('startdate', e)}
                  value={input.startdate}
                  max={input.enddate - 1}
                />
              )}
            </Row>
          </Col>
          <Col className='confHeader exeCard' flex={'5%'}>
            {' '}
            TO{' '}
          </Col>
          <Col className='confHeader exeCard' flex={'25%'}>
            <Row hidden={edit}>
              <Col flex={'auto'}>
                <Row>
                  S
                  {enddate >= 0 ? '+' + enddate.toString() : enddate.toString()}
                </Row>
                <Row>
                  {moment(props.patient?.surgery?.date)
                    .add(enddate, 'd')
                    .format('MM/DD/YYYY')}
                </Row>
              </Col>
              
            </Row>
            <Row hidden={!edit}>
              {props.editPage ? (
                <DatePicker
                  showToday={false}
                  /*disabled={disablePicker(enddate)}
                                    disabledDate={(current) => disabledDate(current, SCHED_TYPE.ENDDATE)}*/
                  value={moment(props.patient?.surgery?.date).add(
                    input.enddate,
                    'd'
                  )}
                  onChange={(e) =>
                    e
                      ? handleChange('enddate', getDays(e.toDate()))
                      : handleChange('enddate', input.enddate)
                  }
                />
              ) : (
                <InputNumber
                  onChange={(e) => handleChange('enddate', e)}
                  value={input.enddate}
                  min={input.startdate + 1}
                />
              )}
              <Checkbox
                checked={skiponsurgerydate}
                onChange={(e) => setSkip(e.target.checked)}
              >
                Skip on surgery date
              </Checkbox>
            </Row>
          </Col>
          <Col className='confHeader exeCard' flex={'35%'}>
            <Row hidden={edit}>
              <Col flex={'auto'}>
                <Row>{util.intervalOptions(interval)}</Row>
              </Col>
            </Row>
            <Row hidden={!edit}>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                style={{ minWidth: 150 }}
                defaultValue={1}
                value={interval || 7}
                onChange={(e) => {
                  setInterval(parseInt(e))
                  handleChange('interval', e)
                }}
              >
                {/* <Select.Option value={0}>Everyday</Select.Option>
                          <Select.Option value={1}>Once A Week</Select.Option>
                          <Select.Option value={2}>Two Times Week</Select.Option>
                          <Select.Option value={3}>Three Times Week</Select.Option>
                          <Select.Option value={4}>Four Times Week</Select.Option>
                          <Select.Option value={5}>Five Times Week</Select.Option>
                          <Select.Option value={6}>Six Times Week</Select.Option> */}
                {renderIntervalOptions()}
              </Select>
                <Checkbox
                  checked={applyAll}
                  onChange={() => setApplyAll(!applyAll)}
                >
                  Apply to all
                </Checkbox>             
            </Row>
          </Col>
        </Row>
      </Col>
      <Col flex={edit ? '65px' : '30px'}>
        <Row align='middle' gutter={5}>
          <Col hidden={edit || props.editOhers}>
            <FormOutlined
              id={'editexe'}
              className='editIcon'
              onClick={() => setEdit(!edit)}
            />
          </Col>
          <Col hidden={!edit}>
            <CloseCircleOutlined className='editIcon' onClick={handleCancel} />
          </Col>
          <Col hidden={!edit}>
            <CheckCircleOutlined
              className='editIcon'
              onClick={applyAll ? showConfirmDeleteBox :skiponsurgerydate ? showConfirmeBoxSkipForAll : handleSubmit}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

Schedule.propTypes = {
  customer: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    patient: state.patient.newpatient,
    exercises: state.schedule.exercises,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setExercises: (exercises) => dispatch(setExercises(exercises)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Schedule)
